import React from 'react'
import SearchableStaffSelectListViewContainer from '../../components/SearchableStaffSelectListViewContainer'
import { isEmpty } from 'lodash'

export default ({
  isShow,
  onHide,
  reservation,
  jobAssignment,
  targetStaff,
  onStaffSelect,
  isSubmitValid,
  onSubmit,
}) => {
  if ([reservation, jobAssignment].some(isEmpty)) return null
  if (!isShow) return null

  const { staff: currentStaff, service } = jobAssignment
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onHide} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">REASSIGN</h2>
          <button
            onClick={onHide}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
            <div className="md:col-span-7">
              <dl className="space-y-3">
                <div className="flex">
                  <dt className="w-40 font-semibold text-gray-700">Service:</dt>
                  <dd className="flex-1 text-gray-900">
                    {service.displayName}
                  </dd>
                </div>
                <div className="flex">
                  <dt className="w-40 font-semibold text-gray-700">
                    Reservation:
                  </dt>
                  <dd className="flex-1 text-gray-900">
                    {reservation.confirmationNumber}
                  </dd>
                </div>
                <div className="flex">
                  <dt className="w-40 font-semibold text-gray-700">
                    Reassign From:
                  </dt>
                  <dd className="flex-1 text-gray-900">
                    {renderStaffName(currentStaff)}
                  </dd>
                </div>
                <div className="flex">
                  <dt className="w-40 font-semibold text-gray-700">
                    Reassign To:
                  </dt>
                  <dd className="flex-1 text-gray-900">
                    {renderAssignTo(targetStaff)}
                  </dd>
                </div>
              </dl>
            </div>
            <div className="md:col-span-5">
              <SearchableStaffSelectListViewContainer
                onStaffSelect={onStaffSelect}
              />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end p-6 border-t border-gray-200 gap-3">
          <button
            onClick={onSubmit}
            disabled={!isSubmitValid}
            className={`px-6 py-3 rounded-lg font-semibold text-lg transition-colors duration-200 ${
              isSubmitValid
                ? 'bg-primary hover:bg-primary-dark text-white cursor-pointer'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

const renderAssignTo = (targetStaff) => {
  if (targetStaff) return <strong>{renderStaffName(targetStaff)}</strong>
  return (
    <span className="inline-block bg-blue-500 text-white px-3 py-1 rounded-md text-base">
      Choose staff on the right
    </span>
  )
}

const renderStaffName = (staff) => `${staff.firstName} ${staff.lastName}`
